import LoginFormEntries from './LoginFormEntries';
import LoginFormHero from './LoginFormHero';

const LoginForm = (props) => {
  return (
    <div className="lg:1/2 md:w-1/2 bg-gray-100 rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0">
      <LoginFormHero name={props.name} />
      <LoginFormEntries login={props.login} />
    </div>
  );
};

export default LoginForm;
